import { Box, IconButton, styled } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { ReactComponent as SearchIconPlaceHolder } from "assets/icons/searchicon.svg";
import Button from "components/ui/Button";
import RemoveModal from "components/ui/RemoveModal/RemoveModal";
import config from "configs/config";
import { useGlobalContext } from "context/GlobalContext";
import SortContext from "context/SortContext";
import collectionDataJson from "db/collectionData.json";
import { useCreateCatalog } from "features/catalogue/hooks/useCreateCatalog";
import { useEditCatalog } from "features/catalogue/hooks/useEditCatalog";
import { useCreateSet } from "features/set/api/create-set";
import { useUpdateSet } from "features/set/api/update-set";
import { useRemoveDesings } from "features/set/hooks/useRemoveDesigns";
import { getLimits } from "features/Setting/Limits/api/limitsApis";
import useCreateCollection from "hooks/useCreateCollection";
import apiClient from "lib/api-client";
import debounce from "lodash.debounce";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { clearCart, clearMeltingCart } from "store/cartSlice";
import { getUserDetail } from "utils/getUserDetailsHelper";
import { addCatalogData } from "utils/updateCatalogData";

const StyledButton = styled(Button)(({ theme, bgcolor, filled }) => ({
  width: "100%",
  fontFamily: "Poppins",
  fontWeight: 500,
  fontSize: "18px",
  lineHeight: "22px",
  height: "42px",
  borderRadius: "5px",
  color: filled ? "#000000" : bgcolor ? bgcolor : "#ffffff",
  border: `1px solid ${bgcolor ? bgcolor : "#ffffff"}`,
  textTransform: "none",
  backgroundColor: filled ? bgcolor : "transparent",
  "&:hover": {
    backgroundColor: bgcolor,
    color: "black",
  },
  "&.Mui-disabled": {
    backgroundColor: "#000000",
    color: "#8B8B8B",
    border: "1px solid #8B8B8B",
  },
}));

function CartShowHeader({ Search, StyledInputBase, btnTitle, setCountCart, countCart, origin }) {
  const [newName, setNewName] = useState("");
  const [collectionData, setCollectionData] = useState(collectionDataJson);
  const [clearCartModal, setClearCartModal] = useState(false);
  const [disable, setDisable] = useState(false);
  const [tempSearch, setTempSearch] = useState("");
  const location = useLocation();
  const userData = localStorage.getItem("userData");
  const [limit, setLimit] = useState();
  const [meltingModalOpen, setMeltingModalOpen] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [loading, setLoading] = useState(false)
  const updateCatalogInFlightRef = useRef(false);

  const dispatch = useDispatch();
  const resolvedBackPath = origin?.isMeltingFlow ? "/Stock" : origin?.backPath;

  const { setCartData, cartData, setUpdateCatalogProductsData } = useGlobalContext();

  const { mutate: createCollection, isPending: isCreatingCollection } = useCreateCollection();

  const navigate = useNavigate();
  const clearCartData = () => {
    setCartData([]);
    dispatch(clearCart());
  };
  const { mutate: createCatalog, isPending: isCreateCatalogLoading } = useCreateCatalog(origin, clearCartData);

  useEffect(() => {
    const fetchLimits = async () => {
      try {
        const userDataParsed = JSON.parse(userData);
        const data = await getLimits(userDataParsed?._id);
        const limit = data?.exists?.designAddLimit;
        setLimit(limit);
      } catch (error) {
        console.error("Error fetching limits:", error);
      }
    };

    fetchLimits();
  }, []);

  const { searchPlaceHolder, setDynamicFilterCount } = useGlobalContext();
  const { setSearch, search } = useContext(SortContext);

  const handleSearch = () => {
    setSearch(tempSearch);
    setDynamicFilterCount(false);
  };

  useEffect(() => {
    setTempSearch(search);
  }, [search]);

  useEffect(() => {
    if (tempSearch === "") {
      setSearch("");
    }
  }, [tempSearch]);

  const handleDiscardChanges = useCallback(() => {
    if (btnTitle === "Create Melting Stock" || origin?.isMeltingFlow) {
      dispatch(clearMeltingCart());
    } else {
      dispatch(clearCart());
    }
    // setCartData([]);
    setNewName("");
    // setCountCart(0);
    // sessionStorage.removeItem("RecentlyRemoved");
    // sessionStorage.removeItem("CartData");
    sessionStorage.removeItem("createName");
    setClearCartModal(false);
    if (origin?.cataloguUpdate) {
      let state = {
        // subName: "Edit",
        // edit: true,
        // innerChnages: false,
        catalogSearch: "",
        name: origin?.backName,
        // catalogueName: origin?.cataloguUpdate ? origin?.catalogueName : "",
        // cataloguUpdate: origin?.cataloguUpdate ? false : true,
        view: false,
      };
      navigate(resolvedBackPath, { state });
    } else if (origin?.collectionUpdate) {
      let state = {
        innerChnages: false,
        name: origin?.backName,
        catalogueName: origin?.collectionUpdate ? origin?.catalogueName : "",
        collectionUpdate: origin?.collectionUpdate ? false : true,
        collection: true,
      };
      navigate(resolvedBackPath, { state });
    } else {
      navigate(resolvedBackPath);
    }
  }, [setCountCart, btnTitle, resolvedBackPath]);

  //-------------------------------------Start cereat catalog---------------------------------------//

  const handleCreateCatalogue = useCallback(() => {
    const cartData = JSON.parse(sessionStorage.getItem("CartData")) || [];

    // const findUniqueData = [...new Set(cartData.map((item) => item.id || item._id))];
    // const findUniqueData = [...new Set(cartData.map((item) => (item.styleId ? item.styleId : item.id || item._id)))];
    const findUniqueData = [...new Set(cartData.map((item) => item.id || item._id))];

    const userId = getUserDetail("_id") || "66e81ad067984093881d174b";

    const newCatalog = {
      catalogName: newName,
      userRef: userId,
      selectedDesignIds: findUniqueData,
    };
    createCatalog(newCatalog);
    // console.log('response',response);

    // setCartData([])
  }, [createCatalog, newName]);

  const { mutate: updateCatalog } = useEditCatalog();

  useEffect(() => {
    if (limit === cartData?.length) {
      setDisable(false);
    }
  }, [cartData, newName]);

  //-------------------------------------end cereat catalog---------------------------------------//

  // ----------------------------------- Craeting Collection Start-------------------------------------------\\
  const queryClient = useQueryClient();
  const handleCreateCollection = useCallback(async () => {
    // const userInfo = JSON.parse(sessionStorage.getItem("userData"))._id; // issue here

    const userInfo = getUserDetail("_id");

    const cartInfo = JSON.parse(sessionStorage.getItem("CartData"));

    const getCartIds = cartInfo.map((data) => data.id || data?._id);

    const newCollection1 = {
      collectionName: newName,
      userRef: userInfo, // A valid User ID
      selectedDesignIds: getCartIds,
    };

    createCollection(newCollection1, {
      onSuccess: (data) => {
        if (data?.data?.status === 200) {
          handleDiscardChanges();
          queryClient.removeQueries("collectionCountData");
          navigate(resolvedBackPath);
        } else if (data?.data?.status === 409) {
          toast.error(`${data?.data?.message}`, {
            autoClose: 1000, // Disappears after 1 seconds
            hideProgressBar: false, // Ensure progress bar is shown
          });
        }
      },
      onError: (error) => {
        console.error("Error creating collection:", error);
        toast.error(`${error?.response?.data?.message}`, {
          autoClose: 1000, // Disappears after 1 seconds
          hideProgressBar: false, // Ensure progress bar is shown
        });
      },
    });
  }, [newName, countCart, collectionData, handleDiscardChanges, navigate, origin?.backPath]);

  //----------------- handleUpdateCollection start --------------------\\
  const handleUpdateCollection = async () => {
    setDisable(true);

    try {
      let updateProductData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
      let cartProductData = JSON.parse(sessionStorage.getItem("CartData")) || [];
      // sessionStorage.removeItem("CartData");
      // setCartData([]);
      dispatch(clearCart());
      // updateProductData = [...updateProductData, ...cartProductData];
      updateProductData = cartProductData;

      sessionStorage.setItem("updateProductsData", JSON.stringify(updateProductData));
      // setCountCart(0);
      let state = {
        innerChnages: false,
        name: origin?.backName,
        catalogueName: origin?.collectionUpdate ? origin?.catalogueName : "",
        collectionUpdate: origin?.collectionUpdate ? false : true,
        collection: true,
      };

      let payload = {
        collectionId: JSON.parse(sessionStorage.getItem("collectionIdOfProducts")),
        styleRefIds: updateProductData.map((style) => style.id),
      };
      let updateCollection = await apiClient.post(`${config.baseUrl}/api/v1/collection/addDesignsToCollection`, payload);

      if (updateCollection.status === 200) {
        queryClient.removeQueries("collectionCountData");

        toast.success(`${"Collection Updated Succesfully "}`, {
          autoClose: 1000,
          hideProgressBar: false,
        });
        sessionStorage.removeItem("updateProductsData");
        sessionStorage.removeItem("collectionIdOfProducts");

        navigate(resolvedBackPath, { state });
      } else {
        alert("Something Went wrong !!!");
        setDisable(false);
      }
    } catch (error) {
      setDisable(false);
    }
  };
  //----------------- handleUpdateCollection end ----------------------\\

  // ----------------------------------- Craeting Collection End -------------------------------------------\\

  //  ====================================UPDATING THE SET=============================
  const { createAddDesignsPayload } = useRemoveDesings();
  const { mutate: updateSetMutation } = useUpdateSet({
    onCompleted: () => {
      const addedDesingCount = JSON.parse(sessionStorage.getItem("CartData")) || [];
      let updatProductData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
      const backName = origin?.backName[0];
      const [setPrefix, prevCount] = backName.split(" - ");
      const updatedCount = parseInt(prevCount, 10) + addedDesingCount.length;
      const updatedBackName = [`${setPrefix} - ${updatedCount}`];

      // sessionStorage.removeItem("CartData");

      // setCartData([]);
      dispatch(clearCart());

      updatProductData = [...updatProductData, ...addedDesingCount];
      sessionStorage.setItem("updateProductsData", JSON.stringify(updatProductData));
      setUpdateCatalogProductsData(updatProductData);

      // setCountCart(0);
      let state = {
        innerChnages: false,
        name: updatedBackName,
        catalogueName: origin?.cataloguUpdate ? origin?.catalogueName : "",
        setUpdate: origin?.cataloguUpdate ? false : true,
      };

      const setId = encodeURIComponent(origin?.setId);
      const setNumberAndCount = encodeURIComponent(`${origin?.catalogueName} - ${parseInt(origin?.setCount) + addedDesingCount.length}`);

      // navigate(origin?.backPath, { state });

      navigate(`/Sets/${setId}?setNumber=${setNumberAndCount}`, { state });
    },
  });

  const handleUpdateSet = () => {
    updateSetMutation(createAddDesignsPayload(origin?.setId));
  };

  // =======================================END OF UPDATE SET===========================

  // ===================================CREATING THE SET================================
  const { mutate: createSet } = useCreateSet({
    onCompleted: () => {
      // Reset the cart and navigate back on successful creation
      sessionStorage.removeItem("CartData");
      setCartData([]);
      setCountCart(0);
      navigate(resolvedBackPath);
    },
  });

  const handleCreateSet = useCallback(() => {
    createSet();
  }, [newName, countCart]);
  // =====================================END CREATE SET==================================

  const returnBtnTitle = useMemo(() => {
    let title;
    if (origin?.cataloguUpdate) {
      title = {
        name: "Update Catalog",
        input: false,
        placeholder: "",
        // click: () => {
        //   let updatProductData = JSON.parse(sessionStorage.getItem("updateProductsData")) || [];
        //   let cartProductData = JSON.parse(sessionStorage.getItem("CartData")) || [];
        //   dispatch(clearCart());
        //   // sessionStorage.removeItem("CartData");
        //   // setCartData([]);
        //   updatProductData = [...updatProductData, ...cartProductData];
        //   sessionStorage.setItem("updateProductsData", JSON.stringify(updatProductData));
        //   setUpdateCatalogProductsData(updatProductData);
        //   // setCountCart(0);
        //   let state = {
        //     // subName: "Edit",
        //     edit: true,
        //     innerChnages: false,
        //     name: origin?.backName,
        //     catalogueName: origin?.cataloguUpdate ? origin?.catalogueName : "",
        //     cataloguUpdate: origin?.cataloguUpdate ? false : true,
        //   };
        //   navigate(origin?.backPath, { state });
        // },
        click: () => {
          const data = addCatalogData();

          if (data?.addDesigns?.length < 1) {
            toast.error("Please add a design to Update Catalog", {
              autoClose: 2000,
              hideProgressBar: false,
            });
            return;
          }

          if (loading || updateCatalogInFlightRef.current) return;
          updateCatalogInFlightRef.current = true;
          setLoading(true);

          updateCatalog(data, {
            onSuccess: (response) => {
              let state = {
                edit: false,
                innerChnages: false,
                name: origin?.backName,
                catalogueName: origin?.cataloguUpdate
                  ? origin?.catalogueName
                  : "",
                cataloguUpdate: origin?.cataloguUpdate ? false : true,
                // view:false,
              };
              updateCatalogInFlightRef.current = false;
              setLoading(false);

              navigate(`${location?.state?.backPath}`, { state });
            },

            onError: (error) => {
              updateCatalogInFlightRef.current = false;
              setLoading(false);
              toast.error(error?.response?.data?.message || "Error updating catalog", {
                autoClose: 1000,
                hideProgressBar: false,
              });
            },
          });
        },
      };
    } else if (origin?.setUpdate) {
      title = {
        name: "Update set",
        input: false,
        placeholder: "",
        click: handleUpdateSet,
      };
    } else if (origin?.collectionUpdate) {
      title = {
        name: "Update Collection",
        input: false,
        placeholder: "",
        click: handleUpdateCollection,
      };
    } else if (origin?.isMeltingFlow) {
      title = {
        name: "Submit Melting Request",
        click: () => {
          setMeltingModalOpen(true);
        },
        input: false,
        placeholder: "",
      };
    } else {
      switch (btnTitle) {
        case "New Catalog": {
          title = {
            name: "Create Catalog",
            click: handleCreateCatalogue,
            input: true,
            placeholder: "Catalog",
          };
          break;
        }
        case "New Collection": {
          title = {
            name: "Create Collection",
            click: handleCreateCollection,
            input: true,
            placeholder: "Collection",
          };
          break;
        }
        case "New Set": {
          title = {
            name: "Create Set",

            click: handleCreateSet,
            // click: () => {
            //   const products = JSON.parse(sessionStorage.getItem("CartData")) || [];
            //   localStorage.setItem("set", JSON.stringify(products));
            //   sessionStorage.removeItem("CartData");
            //   setCountCart(0);
            //   navigate(origin?.backPath);
            // },
            input: false,
            placeholder: "",
          };
          break;
        }

        case "Create Melting Stock": {
          title = {
            name: "Submit Melting Request",
            click: () => {
              setMeltingModalOpen(true);
            },
            input: false,
            placeholder: "",
          };
          break;
        }
        default: {
          title = {
            name: "Update",
            click: () => {
              alert("Navigate To Edit Page");
            },
          };
        }
      }
    }
    return title;
  }, [btnTitle, handleCreateCatalogue, origin, cartData, resolvedBackPath]);

  const btnInfo = useMemo(
    () => [
      {
        btnName: returnBtnTitle.name,
        bgColor: "#50C878",
        click: returnBtnTitle.click,
      },
      {
        btnName: "Clear Cart",
        bgColor: "#E77B7B",
        click: () => {
          setClearCartModal(true);
        },
      },
    ],
    [returnBtnTitle, handleDiscardChanges]
  );

  const isMeltingRequest = returnBtnTitle.name === "Submit Melting Request";

  const displayBtnInfo = useMemo(() => {
    if (isMeltingRequest) {
      return [
        {
          btnName: returnBtnTitle.name,
          bgColor: "#50C878",
          filled: true,
          click: returnBtnTitle.click,
        },
        {
          btnName: "Cancel",
          bgColor: "#E77B7B", // Or transparent/border only if you want to match the image exactly
          click: () => {
            // This acts as "Clear/Cancel"
            setClearCartModal(true);
          },
        },
      ];
    }
    return btnInfo;
  }, [btnInfo, isMeltingRequest, returnBtnTitle]);

  const clearCartBtnInfo = [
    {
      btnName: isMeltingRequest ? "Discard" : "Clear",
      bgColor: "#E77B7B",
      click: () => handleDiscardChanges(),
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => setClearCartModal(false),
    },
  ];

  const meltingBtnInfo = [
    {
      btnName: "No",
      bgColor: "#E77B7B",
      click: () => setMeltingModalOpen(false),
    },
    {
      btnName: "Yes",

      bgColor: remarks ? "#50C878" : "#424242",
      disabled: !remarks,
      click: async () => {
        if (!remarks) return;
        //Logic to submit melting request
        //console.log("Melting Request Submitted with remarks:", remarks);
        try {
          const cartProductData = JSON.parse(sessionStorage.getItem("CartData")) || [];
          const meltingStockJewelCode = cartProductData.map((item) => item.jewelCode);

          const payload = {
            meltingStockJewelCode,
            remark: remarks,
          };
          const response = await apiClient.post(`${config.baseUrl}/api/v1/melting_request/add`, payload);

          if (response.status === 200) {
            toast.success("Melting Request Submitted Successfully");
            setMeltingModalOpen(false);
            setRemarks("");
            dispatch(clearCart());
            dispatch(clearMeltingCart());
            navigate(resolvedBackPath);
          } else {
            toast.error("Failed to submit melting requet");
          }
        } catch (error) {
          console.error("Melting Request error", error);
          toast.error(error?.response?.data?.message || "Something went wrong");
        }
      },
    },
  ];

  const handleInputChange = useCallback((e) => {
    let updatedName = e.target.value;
    updatedName = updatedName.replace(/^\s+/, "");
    setNewName(updatedName);
    debounceSessionUpdateCreatName(updatedName);
  }, []);

  const debounceSessionUpdateCreatName = useCallback(
    debounce((updatedName) => {
      sessionStorage.setItem("createName", JSON.stringify(updatedName));
    }, 300),
    []
  );

  useEffect(() => {
    const createName = JSON.parse(sessionStorage.getItem("createName")) || "";
    if (createName) {
      setNewName(createName);
    }
  }, []);

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>
      {returnBtnTitle.input ? (
        <Search>
          <StyledInputBase placeholder={`Nickname For ${returnBtnTitle.placeholder}`} onChange={handleInputChange} value={newName} inputProps={{ "aria-label": "search" }} />
        </Search>
      ) : null}
      {location.pathname === "/CartOrder" && (
        <Search
          sx={{
            display: "flex",
            alignItems: "center",
            paddingLeft: "10px",
            paddingRight: "4px",
          }}
        >
          {/* Search Icon inside Input */}
          <SearchIconPlaceHolder sx={{ color: "gray", marginRight: "8px" }} />

          <StyledInputBase
            placeholder={"Search By Design Number"}
            onChange={(e) => setTempSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            value={tempSearch}
            inputProps={{ "aria-label": "search" }}
            sx={{ height: "40px", borderRadius: "5px" }}
          />

          <IconButton
            disableRipple
            disableFocusRipple
            sx={{
              color: "black",
              height: "34px",
              width: "69px",
              borderRadius: "5px",
              padding: "10px",
              background: "#000",
              fontFamily: "poppins",
              color: "#fff",
              fontWeight: "500",
              fontSize: "12px",
            }}
            onClick={search === "" ? handleSearch : () => setSearch("")}
          >
            {search === "" ? "Search" : "Clear"}
          </IconButton>
        </Search>
      )}

      {(location.pathname !== "/CartOrder" || isMeltingRequest) && (
        <>
          {displayBtnInfo.map((btn) => (
            <>
              <Box key={btn.btnName}>
                <StyledButton
                  bgcolor={btn.bgColor}
                  filled={btn.filled}
                  onClick={() => {
                    btn.click();
                    // if (btn.btnName === "Create Catalog") {
                    setDisable(true);
                    // }
                  }}
                  disabled={
                    (btn.btnName === returnBtnTitle.name && returnBtnTitle.input ? !newName : false) ||
                    (disable && btn.btnName === "Update Collection") ||
                    (btn.btnName === "Create Collection" && isCreatingCollection) ||
                    (btn.btnName === "Create Catalog" && isCreateCatalogLoading) ||
                    (btn.btnName === "Update Catalog" && loading)
                  }
                >
                  {btn.btnName}
                </StyledButton>
              </Box>
            </>
          ))}
          <RemoveModal
            open={clearCartModal}
            setOpen={setClearCartModal}
            heading={isMeltingRequest ? "Do you want to discard all changes?" : "Do you want to clear the cart?"}
            btnInfo={clearCartBtnInfo}
          />
          <RemoveModal open={meltingModalOpen} setOpen={setMeltingModalOpen} heading="Are you sure you want to submit melting request?" btnInfo={meltingBtnInfo} cumWidth="500px" gap={0}>
            <Box sx={{ width: "100%", textAlign: "left", marginTop: "26px" }}>
              <div style={{ fontFamily: "Poppins", fontSize: "14px", fontWeight: "500", marginBottom: "8px", color: "black" }}>
                Remarks<span style={{ color: "red" }}>*</span>
              </div>
              <textarea
                value={remarks}
                onChange={(e) => setRemarks(e.target.value)}
                placeholder="Enter Remarks"
                style={{
                  width: "100%",
                  height: "105px",
                  padding: "10px",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                  fontFamily: "Poppins",
                  fontSize: "14px",
                  resize: "none",
                  outline: "none",
                }}
              />
            </Box>
          </RemoveModal>
        </>
      )}
    </Box>
  );
}

export default CartShowHeader;
